import React from "react";
import { Link } from "react-router-dom";
import Sidebar from "../component/Sidebar";
import Drawer from "@material-ui/core/Drawer";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import NfcIcon from "@material-ui/icons/Nfc";
import { makeStyles } from "@material-ui/core/styles";
import cookie from 'react-cookie';
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import HeaderBackButton from "../component/HeaderBackButton";
import HeadsetIcon from "@material-ui/icons/Headset";
import queryString from 'query-string';

//var Router = require("react-router");

const useStyles = makeStyles({
	list: {
		width: 320
	}
});

function setCookie_QS(initial_querystring) {
    let d = new Date();
    d.setTime(d.getTime() + (12 * 60 * 60 * 1000));
    cookie.save("initial_querystring", initial_querystring, { path: "/", expires: d });
};


function getOS() {
    var userAgent = window.navigator.userAgent,
            platform = window.navigator.platform,
            macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
            windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
            iosPlatforms = ['iPhone', 'iPad', 'iPod'],
            iphonePlatforms = ['iPhone','iPod'],
            ipadPlatforms = ['iPad'],
    os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'Mac OS';
        if(userAgent.indexOf("iPad;")>-1) os = 'iPad';
    } else if (ipadPlatforms.indexOf(platform) !== -1) {
        os = 'iPad';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'Windows';
    } else if (/Android/.test(userAgent)) {
        os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
        os = 'Linux';
    }

    if(userAgent.indexOf("CPU OS 12_")> -1 && (os==='iPad'||os==='iOS')) {
        os='iPad12';
    }
    return os;
}

function jump_home() {
    var qs= cookie.load("initial_querystring");
    let signin_url="/Home"+qs;
    //console.log("new home url "+signin_url);
    //props.history.push(signin_url);
    //props.history.replace(signin_url);
    window.location.href=signin_url;
}


function jump_audiobook_home() {
    var qs= cookie.load("initial_querystring");
    let signin_url="/HomeAudioBook"+qs;
    //console.log("new home url "+signin_url);
    //props.history.push(signin_url);
    //props.history.replace(signin_url);
    window.location.href=signin_url;
}


function jump_apple_app_store() {
    var qs= cookie.load("initial_querystring");
    //let signin_url="/Guide_GoogleStore";
    //let signin_url="http://thechaek.com/";
    let signin_url="https://apps.apple.com/ph/app/%EC%8A%A4%EB%A7%88%ED%8A%B8%EB%8D%94%EC%B1%85/id1491869903?ign-mpt=uo%3D2";
    window.location.href=signin_url;
}

function jump_google_app_store() {
    var qs= cookie.load("initial_querystring");
    //let signin_url="/Guide_AppleStore";
    //let signin_url="http://thechaek.com/";
    //let signin_url="market://details?id=com.mediachangbi.app.audiobook";
    let signin_url="https://play.google.com/store/apps/details?id=com.mediachangbi.app.audiobook";
    window.location.href=signin_url;
}



export default function Landing(props) {

	//<IconButton>
	//	<NfcIcon />
	//</IconButton>

    //alert(JSON.stringify(props));
	var strHeaderTitle = "";

    if (props.headerTitle === undefined || props.headerTitle === null) {
		strHeaderTitle = "더책";
	}
	else {
		strHeaderTitle = props.headerTitle + "";
	}

	const classes = useStyles();
	const [state, setState] = React.useState({
		right: false, headerTitle: strHeaderTitle
	});
	
	const toggleDrawer = (side, open) => event => {
		if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
			return;
		}

		setState({ ...state, [side]: open });
	};

	const sideList_org = side => (
		<div className={classes.list} role="presentation" onKeyDown={toggleDrawer(side, false)}>
			<Sidebar />
		</div>
	);
	const sideList = side => (
		null
	);



	if(window.navigator.userAgent.indexOf("MCB_MOBILE")=== -1) {
	    if(getOS()==='iOS' || getOS()==='iPad' ) {
	        console.log("bad connection from "+getOS()+" "+window.navigator.userAgent);
            setTimeout(jump_apple_app_store,200);
            return "";
        };
        if( getOS()==='Android') {
            setTimeout(jump_google_app_store,200);
            return "";
        };
        }

    var qs = window.location.search;
    if(qs===undefined || qs==="" || qs===null) {



        qs=cookie.load("initial_querystring");
        if(qs===undefined || qs==="" || qs===null) {
            qs= "?device_userid=967dbb95-6a1e-4cbc-bdae-6f5df66f24e4&device_password=B716A34E-95F9-48CA-AF57-9FD65DEFD05A&device_model=WEBTEST&device_os=14.0.1&app_version=2.0.0";
        }
    };
    let params = queryString.parse(qs);
    setCookie_QS(qs);
    //console.log("this is / LandingPage");
    //console.log(window.location.href);
    //alert(window.location.href+JSON.stringify(params));
    //console.log(params);




	//if(getOS()==='iPad') {
    //    setTimeout(jump_audiobook_home,200);
    //    return "";
    //}
	if(true) {
        setTimeout(jump_home,200);
        return "";
    }


	let struserid = cookie.load("userid");
	var struserdbid = cookie.load("userdbid");
	var strorgid = cookie.load("orgid");
	var orgname = cookie.load("orgname");

	if (typeof (struserdbid) === 'undefined')
		struserdbid = '0';

	if (typeof (strorgid) === 'undefined')
		strorgid = "0";

	if (typeof (orgname) === 'undefined')
		orgname = state.headerTitle;



	let strBackInfo = "";
	var strHeaderTitle =   <h2 className='landing-lsb-message'>이용하실 서비스를 선택해주세요 </h2> ;
	//console.log("landing url: " + window.location.href);
	var qs = window.location.search;
	if (qs === "?") {
		qs = "";
	}
	if (window.location.pathname != "/") {
		strBackInfo = <HeaderBackButton />
		strHeaderTitle = "";
	}

	let logoimage = "";
	if (strorgid != "0")
	{
		var strlogoimageurl = "/api/AB/getliblogoimage?orgid=" + strorgid;
		logoimage = <a href='/'><img src={strlogoimageurl} className='header-logo'/></a>;
		logoimage = "";
	}


        var draw_icon= <div className="header-action">
 					<IconButton onClick={toggleDrawer("right", true)}>
						<MenuIcon />
					</IconButton>
				</div>;
        var drawer=  <Drawer anchor="right" elevation="0" open={state.right} onClose={toggleDrawer("right", false)}>
				{sideList("right")}
			</Drawer>;
  
	return (
		<React.Fragment>
            <header className="header">
                {strBackInfo}{logoimage}
				<h1 className="header-title">
					<Link to="/">{orgname} </Link>
                </h1>
            </header>

<p/>
 <p/>
<center>
            {strHeaderTitle}
 <p/>
            <p>
		 <h2 className="landing-lsb-item">
                            <Link to={"/Home"+qs}><img src={"/assets/images/newimages/mcblsb1.png"}/></Link>
                        </h2>
             </p>
 <p/>
 	 <p>
		 <h2 className="landing-lsb-item">
                            <Link to={"/HomeAudioBook"+qs}><img src={"/assets/images/newimages/mcblsb2.png"}/></Link>
                        </h2>
             </p>
</center>
		</React.Fragment>
	);
}
